import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import LoginService from 'services/Login/';
import Input from 'components/Input';
import { actionsType } from 'config/constants';
import TagManagerService from 'services/TagManager';
import PubSub from 'services/PubSub/';
import { modalPasswordTxt } from 'config/translate/variables';
import style from './style.scss'; //NOSONAR

let _email = null;
let _register = null;
let _firstName = null;
let isValidated = false;
let _lastName = null;
let _goToRegister = false;
let passwordValid = false;
let confirmPasswordValid = false;
let _offerValue = false;
let _termsValue = false;

const ForgetPassword = (props) => {
    const payload = props.payload;
    const modeUpdate = payload && payload.value && payload.value.modeUpdate ? payload.value.modeUpdate : '';
    const [isLogged, setIsLogged] = useState(false);
    const [formInputIsValid, setFormInputIsValid] = useState(false);
    const [error, setError] = useState({
        minChar: false,
        oneLowercase: false,
        alphnumeric: false,
        oneUppercase: false
    });

    const inputPassword = useRef();
    const inputRepeatPassword = useRef();
    
    

    useEffect(() => {
        if(payload) {
            _open(payload);
        }
    }, [payload]);

    useEffect(() => {
        return function cleanup() {
            passwordValid = false;
            confirmPasswordValid = false;
        }
    }, [])

    const _open = (data) => {
        const { email, register, goToRegister } = data ? data.value : {};
        _email = email;
        _register = register || null;
        _firstName = register ? register.firstName : '';
        _lastName = register ? register.lastName : '';
        isValidated = false;
        _offerValue = register ? register.isNewsletterOptIn : false;
        _termsValue = register ? register.terms : false;
        _goToRegister = goToRegister;
        setIsLogged(LoginService.isLogged());
        setError({
            minChar: false,
            oneLowercase: false,
            alphnumeric: false,
            oneUppercase: false
        })
    }

    const _getEmailIsPassword = (isValid) => {
        passwordValid = isValid;
    }

    const validateForm = () => {
        const isvalid = (passwordValid && confirmPasswordValid);

        if (isvalid !== formInputIsValid) {
            setFormInputIsValid(isvalid);
        }
    }

    const validatePassword = (value) => {
        let bug = _getErrorStep(value);

        let isValid = !bug.minChar && !bug.oneLowercase && !bug.oneUppercase && !bug.alphnumeric;

        isValidated = true;

        setError(bug);

        return isValid;
    }

    const _getErrorStep = (value) => {
        let e = {
            minChar: true,
            oneLowercase: true,
            alphnumeric: true,
            oneUppercase: true
        };

        e.minChar = value.length < 8;
        e.oneLowercase = !value.match(/[a-z]/g);
        e.oneUppercase = !value.match(/[A-Z]/g);
        e.alphnumeric = !(value.match(/[a-z, A-Z]/g) && value.match(/[0-9]/g));

        return e;
    }

    const _getConfirmPasswordValid = (isValid) => {
        confirmPasswordValid = isValid;
    }

    const validateConfirmPassword = (value) => {
        const password = inputPassword.current ? inputPassword.current.value : null;

        return value === password;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!formInputIsValid) return false;

        const password = inputPassword.current || null;

        if (!password) return false;

        LoginService.sendUserAccessKey(_email).then(result => {
            if (result) {
                close();
                PubSub.dispatch('validation_code_open', {
                    email: _email,
                    firstName: _firstName,
                    lastName: _lastName,
                    password: password.value,
                    register: _register,
                    isNewsletterOptIn: _offerValue,
                    termsValue: _termsValue,
                    modeUpdate,
                });
            }
        });

        if(_goToRegister){
            TagManagerService.logAccount('Registro', 'Step 2: Crea una clave', 'Click');
        }
        
    }

    const close = () => {
        setTimeout(() => PubSub.dispatch(actionsType.MODAL.PASSWORD_CLOSE), 0);
    }

    const goBack = () => {
        if(_goToRegister){
            const form = {
                email: _email,
                firstName: _firstName,
                lastName: _lastName,
                isNewsletterOptIn: _offerValue,
                termsValue: _termsValue
            }
            PubSub.dispatch('register_open', form);
        } else {
            PubSub.dispatch('login_open');
        }
        TagManagerService.logAccount('Ingresa a tu cuenta', 'Ingresa a tu cuenta', window.location.href);

        close();
    }

    return (
        <form className='new-modal-container' onSubmit={handleSubmit}>
            <div className="new-modal-title-wrap"><h3 className="new-modal-title">{modeUpdate ? 'Actualiza tu clave' : 'Crea una clave'}</h3></div>
            <div className={'new-modal-scroll forgot-password-content active'}>
                <div className={'login-wrap'}>
                    <div className="password-info-text">
                        <span>{modalPasswordTxt.message}</span>
                    </div>
                    <strong>Debe tener:</strong>
                    <ul className='password-validation-step'>
                        <li className={error.minChar ? 'is-error' : (isValidated ? 'is-success' : '')}>Mínimo 8 caracteres</li>
                        <li className={error.oneLowercase ? 'is-error' : (isValidated ? 'is-success' : '')}>1 Minúscula</li>
                        <li className={error.alphnumeric ? 'is-error' : (isValidated ? 'is-success' : '')}>Alfanumérica</li>
                        <li className={error.oneUppercase ? 'is-error' : (isValidated ? 'is-success' : '')}>1 Mayúscula</li>
                    </ul>

                    <div className="form-container modal-password" >
                        <div>
                            <Input
                                ref={inputPassword}
                                key={'nueva clave'}
                                className={'input-default'}
                                name={'nueva clave'}
                                label={'Nueva Clave'}
                                value={''}
                                type={'password'}
                                onChange={validatePassword}
                                validate={validatePassword}
                                message={{
                                    "error": "La clave ingresada no cumple con los requisitos"
                                }}
                                validateForm={validateForm}
                                callbackValidate={_getEmailIsPassword}
                            />
                            <Input
                                ref={inputRepeatPassword}
                                key={'confirmar nueva clave'}
                                className={'input-default'}
                                name={'confirmar nueva clave'}
                                label={'Confirmar clave'}
                                value={''}
                                type={'password'}
                                onChange={validateConfirmPassword}
                                validate={validateConfirmPassword}
                                message={{
                                    "error": "Las claves no coinciden"
                                }}
                                validateForm={validateForm}
                                callbackValidate={_getConfirmPasswordValid}
                            />
                        </div>


                    </div>
                </div>
            </div>
            <div className="modal-actions">
                <div className="cont-btn">
                    <button type="submit" className={(formInputIsValid ? 'primary-btn' : 'disabled-btn') + (!modeUpdate ? ' title-default' : ' title-update')}>
                    </button>
                    {!isLogged && <button type="button" className="secundary-btn" onClick={goBack}>
                        <span>Volver</span>
                    </button>}
                    {isLogged && <button type="button" className="secundary-btn" onClick={close}>
                        <span>Cancelar</span>
                    </button>}
                </div>
            </div>
        </form>
    )
}

ForgetPassword.propTypes = {
    payload: PropTypes.object
};

export default ForgetPassword;
